import { configConstants as qz } from "../../../constants/configs";

const initialState = {
  loading: true,
  list: [],
  quiz: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case qz.GET_QUIZ:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case qz.GET_QUIZ_BY_ID:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    default:
      return state;
  }
}
